import fetch from '@/api/fetch'


/** 获取薪酬统计项目树 */
// export const getWageTotalProjectTree = params => fetch.get('/ent/wage/total/project/tree');


/** 获取薪酬统计页面统计 */
export const getSlipTotalStatistics = params => fetch.get('/ent/wage/total/statistics', { params })